import { WizardRouter } from './WizardRouter';
import { WizardInteractor } from './WizardInteractor';
var WizardBuilder = /** @class */ (function () {
    function WizardBuilder(deps) {
        this.deps = deps;
    }
    WizardBuilder.prototype.build = function () {
        var _a, _b;
        var viewController = this.deps.viewController;
        var interactor = new WizardInteractor(null, this.deps.listener, viewController, {
            isNextStepAvailable: (_b = (_a = this.deps.config) === null || _a === void 0 ? void 0 : _a.isNextStepAvailable) !== null && _b !== void 0 ? _b : true
        });
        viewController.listener = interactor;
        var router = new WizardRouter(interactor, viewController, this.deps.steps);
        return {
            router: router,
            actionable: interactor
        };
    };
    return WizardBuilder;
}());
export { WizardBuilder };
//# sourceMappingURL=WizardBuilder.js.map